module.exports = new __parcel__URL__("PRD.56426dd9.svg").toString();